import React from 'react'
import type { PresentationSectionProps } from '../../'
import compareSectionProps from '../../util/compareSectionProps'
import QuoteComponent from '../../../Quote/Quote'
import WorkOrderPlaceholder from './WorkOrderPlaceholder'

function WorkOrderSection(props: PresentationSectionProps) {
  const { WrapperComponent, isSettings, objectLabels } = props

  return (
    <WrapperComponent {...props}>
      {isSettings ? (
        <WorkOrderPlaceholder objectLabels={objectLabels} />
      ) : (
        <QuoteComponent inPresentation={true} view="work-order" />
      )}
    </WrapperComponent>
  )
}

export default React.memo(WorkOrderSection, (prevProps, nextProps) => {
  return compareSectionProps(prevProps, nextProps)
})
